// frontend/src/utils/supplierCategories.js
// Roadmap 3.6 — categorías de proveedor: helpers puros del catálogo editable.
// El catálogo vive en el backend (GET /api/supplier-categories/catalog, con
// siembra perezosa de las 4 históricas); estas funciones solo transforman la
// respuesta y NUNCA dejan un select vacío: si el catálogo no llega, se usan
// las 4 de siempre.

// Las 4 categorías históricas — fallback si el fetch del catálogo falla.
export const DEFAULT_SUPPLIER_CATEGORIES = [
  "Herramientas",
  "Formación",
  "Servicios profesionales",
  "Otros gastos",
];

/**
 * Convierte la respuesta del catálogo ([{catalog_id, name, is_fallback, ...}])
 * en la lista de nombres para los selects. Respuesta inválida o vacía → las 4
 * por defecto (nunca un select vacío).
 */
export function catalogToNames(catalog) {
  if (!Array.isArray(catalog)) return DEFAULT_SUPPLIER_CATEGORIES;
  const names = catalog
    .map((entry) => entry?.name)
    .filter((name) => typeof name === "string" && name.trim() !== "");
  return names.length > 0 ? names : DEFAULT_SUPPLIER_CATEGORIES;
}

/**
 * Línea de fuente de la propuesta de categoría (patrón 3.4).
 * Respuesta de GET /supplier-categories/propose → {kind, label} | null:
 * - history → «Ya conoces este proveedor» (kind "known")
 * - token   → «Proveedor similar» (kind "known")
 * - ai      → reason + confianza % (kind "ai")
 * - sin source o sin category → null (no se pinta nada)
 */
export function proposalSourceLabel(proposal) {
  if (!proposal?.source || !proposal.category) return null;
  if (proposal.source === "history") {
    return { kind: "known", label: "Ya conoces este proveedor" };
  }
  if (proposal.source === "token") {
    return { kind: "known", label: "Proveedor similar" };
  }
  if (proposal.source === "ai") {
    const parts = [];
    if (proposal.reason) parts.push(proposal.reason);
    // ?? / != null: una confianza de 0 sería legítima (no usar truthiness)
    if (proposal.confidence != null) {
      parts.push(`confianza ${Math.round(proposal.confidence * 100)} %`);
    }
    return {
      kind: "ai",
      label: parts.length > 0 ? parts.join(" — ") : "Sugerencia de la IA",
    };
  }
  return null;
}
